import { useState, useEffect } from "react";

export const useIsAdmin = (user) => {
  const [admin, setAdmin] = useState(false);

  useEffect(() => {
    const checkAdminRole = async () => {
      if (user) {
        try {
          const idTokenResult = await user.getIdTokenResult(true);
          setAdmin(idTokenResult.claims.admin === true);
        } catch (error) {
          console.error("Errore durante il controllo del ruolo admin:", error);
          setAdmin(false);
        }
      } else {
        setAdmin(false);
      }
    };

    checkAdminRole();
  }, [user]);

  return admin;
};
